import { T } from "../../app/tokens.js";

// Offices is the reference. Share appearance, not page-specific filter semantics.
// Card and inner header need the same radius: the sticky shell cannot clip
// overflow, so the inner header must contain its own background at the corners.
export const LIST_HEADER_RADIUS = 14;
// Measured from the live Offices collection, not the reference HTML.
export const COLLECTION_GEOMETRY = Object.freeze({ standard: 40, compact: 28, header: 32 });
export const collectionRowHeight = density => density === "compact" ? COLLECTION_GEOMETRY.compact : COLLECTION_GEOMETRY.standard;
export const COLLECTION_PROGRESS = Object.freeze({
  size: 9, gap: 5, ring: 2,
  done: T.projectsPhaseDone, current: T.blue, remaining: T.projectsPhaseFuture, complete: T.green,
});
export const COLLECTION_ONE_LINE = Object.freeze({
  minWidth: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
});
export const LIST_PRESENTATION = {
  name: { fontWeight: T.fwSemibold, color: T.listInk, fontSize: T.fsBase },
  secondary: { color: T.listMuted, fontSize: T.fsXs },
  numeric: { color: "var(--v2-mid)", fontSize: T.fsBase, fontWeight: T.fwRegular },
  header: {
    color: "var(--v2-mid)", fontSize: T.fsXxs, fontWeight: T.fwBold,
    textTransform: "uppercase", letterSpacing: ".07em",
  },
  clear: {
    background: "transparent", border: "1px solid transparent", borderRadius: 8,
    color: T.listAccent, fontSize: T.fsBase, fontWeight: T.fwBold,
    cursor: "pointer", padding: "7px 11px",
  },
  summary: { display: "flex", alignItems: "center", gap: 8, padding: "6px 0 2px", flexWrap: "wrap" },
  count: { fontSize: T.fsSm, color: T.listMuted, flexShrink: 0 },
  chip: {
    display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 10px",
    border: "none", borderRadius: 6, fontSize: T.fsSm,
    color: T.listAccent, background: T.listChipBg, fontWeight: T.fwSemibold, whiteSpace: "nowrap",
  },
  remove: {
    background: "none", border: "none", cursor: "pointer", padding: 0,
    fontSize: T.fsSm, color: T.listAccent, lineHeight: 1, fontWeight: T.fwBold,
  },
  container: {
    background: T.listCard, border: `1px solid ${T.listLine}`,
    borderRadius: LIST_HEADER_RADIUS, boxShadow: T.listCardShadow,
  },
};

export function listHeaderEdges(isStuck) {
  return {
    // Inherited by the overflow adapter's opaque, translated action header.
    "--list-header-radius": `${LIST_HEADER_RADIUS}px`,
    borderTopLeftRadius: LIST_HEADER_RADIUS,
    borderTopRightRadius: LIST_HEADER_RADIUS,
    boxShadow: isStuck ? T.listPinnedShadow : "none",
    transition: "box-shadow 120ms ease",
  };
}
